import './NoDataFound.css'
import Nodata from '../../Images/nodata.webp'

const NoDataFound = ({ message = "No data found" }) => {
  return (
    <div className='NoDataFound-card'>
      <img src={Nodata} alt='No data found' />
      <h3>{message}</h3>
    </div>
  )
}

export default NoDataFound